<template>
  <div class="app-container">
    <el-descriptions title="工单信息" :column="4">
      <el-descriptions-item label="京东工单号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ stationReport.orderNo }}</el-descriptions-item>
      <el-descriptions-item label="回收订单号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineRecycleOrder.recycleNo }}</el-descriptions-item>
      <el-descriptions-item label="京东完成时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{
        formatDateTime(oldMachineRecycleOrder.finishDate)
      }}</el-descriptions-item>
      <el-descriptions-item label="回收完成时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{
        formatDateTime(oldMachineRecycleOrder.recycleCompleteDate)
      }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="网点信息" :column="4" :style="{ 'margin-top': '12px' }">
      <el-descriptions-item label="仓库名称" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ stationDto.stationName }}</el-descriptions-item>
      <el-descriptions-item label="联系电话" :labelStyle="labelStyle" :contentStyle="contentStyle"
        >{{ stationDto.contactMobile }}
        <span v-if="contactMobile">
          <img v-if="!dataVisible.contactMobile" src="@/assets/eye-close.png" @click="toggleVisibility('contactMobile')" />
          <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('contactMobile')" />
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="联系人" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ stationDto.contactName }}</el-descriptions-item>
      <el-descriptions-item label="取货地址" :labelStyle="labelStyle" :contentStyle="contentStyle"
        >{{ formatAddress(stationDto)
        }}<span v-if="stationDto.address">
          <img v-if="!dataVisible.address" src="@/assets/eye-close.png" @click="toggleVisibility('address')" />
          <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('address')" /> </span
      ></el-descriptions-item>
      <!-- <el-descriptions-item label="备注" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ stationReport.exceptionRemark }}</el-descriptions-item> -->
    </el-descriptions>
    <el-descriptions title="旧机信息" :style="{ 'margin-top': '12px' }"></el-descriptions>
    <el-table :data="barCodeList" center style="margin-bottom: 20px;">
      <el-table-column label="旧机类型" prop="category" min-width="140"> </el-table-column>
      <el-table-column label="旧机规格" prop="type" min-width="140"> </el-table-column>
      <el-table-column label="旧机条码" prop="barCode" min-width="140"> </el-table-column>
    </el-table>
    <el-descriptions title="报备信息" :column="1" :style="{ 'margin-top': '12px' }">
      <el-descriptions-item label="异常类型" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ getExceptionTypeDesc(stationReport.exceptionType) }}</el-descriptions-item>
      <el-descriptions-item label="异常情况说明" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ stationReport.exceptionRemark }}</el-descriptions-item>
      <el-descriptions-item label="佐证照片" :labelStyle="labelStyle" :contentStyle="contentStyle">
        <div class="image-container">
          <image-upload class="img-box" :editMode="false" v-for="(item, index) in stationPictureList" :key="index" :imageUrl.sync="item" />
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="佐证视频" :labelStyle="labelStyle" :contentStyle="contentStyle">
        <div class="image-container">
          <div v-if="!stationVideo || !Object.keys(stationVideo).length" class="no-data">暂无佐证视频</div>
          <div v-else :key="'video-' + (stationVideo.annexId || 'default')" class="image-item video-item" @click="handleVideoPreview(stationVideo)">
            <div class="video-cover">
              <i class="el-icon-video-play"></i>
              <span>视频</span>
            </div>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>

    <!-- 视频预览对话框 -->
    <el-dialog title="视频预览" :visible.sync="videoDialogVisible" width="800px" :before-close="handleCloseVideo">
      <div class="video-player-container">
        <video v-if="currentVideoUrl" :src="currentVideoUrl" controls autoplay style="width: 100%; height: 100%;">
          您的浏览器不支持视频播放
        </video>
      </div>
    </el-dialog>

    <div style="text-align: center; margin-top: 20px;">
      <el-button @click="$router.back(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import imageUpload from '@/components/Upload/ImageUpload'
import dayjs from 'dayjs'
export default {
  components: {
    imageUpload
  },
  data() {
    return {
      labelStyle: {
        'font-size': '14px',
        'font-weight': '400',
        'text-align': 'left',
        color: '#9d9d9d'
      },
      contentStyle: {
        'font-size': '14px',
        'font-weight': '400',
        'text-align': 'left',
        color: '#333'
      },
      orderNo: undefined,
      formData: {},
      jdStation: {},
      oldMachineRecycleOrder: {},
      stationPictureList: [],
      stationReport: {},
      stationVideo: {},
      barCodeList: [],
      stationDto: [],
      // 视频预览相关
      videoDialogVisible: false,
      currentVideoUrl: '',

      dataVisible: {
        contactMobile: false,
        address: false
      },
      contactMobile: '',
      address: '',
      originData: {}
    }
  },
  created() {
    this.orderNo = this.$route.query.orderNo
    this.getPageDataFun()
  },
  methods: {
    // 获取页面详情数据
    getPageDataFun() {
      const url = `/autoapp-default-server-recovery/api/jd/stationReport/detail`
      this.HttpService.post(url, { orderNo: this.orderNo }).then(res => {
        if (res.statusCode === 200) {
          this.jdStation = res.data.jdStation || {} //站点信息
          this.oldMachineRecycleOrder = res.data.oldMachineRecycleOrder || {} //京东订单
          this.stationPictureList = res.data.stationPictureList.map(item => item.annexId) || [] //图片
          this.stationReport = res.data.stationReport //网点报备
          this.stationDto = res.data.stationDto
          this.stationVideo = res.data.stationVideo ? res.data.stationVideo.annexId : {} //站点视频
          this.buildBarCodeList()
          this.originData = res.data.stationDto ? { ...res.data.stationDto } : {}
          // 根据 sensitizationCode 拆分数据
        if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
          const phoneMappings = {
            stationDtoContactMobile_phone: 'contactMobile',
            stationDtoAddress_address: 'address'
          }

          res.data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }

        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },

    // 构建条码列表
    buildBarCodeList() {
      const list = []
      const order = this.oldMachineRecycleOrder

      // 添加内机条码
      if (order.oldBarCode1) {
        list.push({
          type: order.fourthOldCate || '',
          category: order.thirdOldCate || '',
          barCode: order.oldBarCode1
        })
      }

      // 添加外机贴码
      if (order.oldBarCode2) {
        list.push({
          type: order.fourthOldCate || '',
          category: order.thirdOldCate || '',
          barCode: order.oldBarCode2
        })
      }

      this.barCodeList = list
    },

    // 时间格式化
    formatDateTime(time) {
      if (!time) return ''
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },

    // 格式化地址，用 - 分割
    formatAddress(dto) {
      if (!dto) return ''
      const parts = [dto.province, dto.city, dto.district, dto.address].filter(part => part && part.trim())
      return parts.join(' - ')
    },

    // 视频预览
    handleVideoPreview(videoUrl) {
      if (videoUrl) {
        videoUrl = process.env.BASE_API +`/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${videoUrl}`
        this.currentVideoUrl = videoUrl
        this.videoDialogVisible = true
      }
    },

    // 关闭视频对话框
    handleCloseVideo(done) {
      this.currentVideoUrl = ''
      this.videoDialogVisible = false
    },
    // 获取异常情况描述
    getExceptionTypeDesc(exceptionType) {
      const exceptionMap = {
        1: '无连接管',
        2: '连接管剪断',
        3: '连接管为铝管',
        4: '用户品牌不一致',
        5: '旧机面板缺失',
        6: '其他'
      }
      return exceptionMap[exceptionType] || ''
    },
    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'contactMobile':
          if (this.dataVisible.contactMobile && this.contactMobile.message) {
            this.getSourceOrigin(this.contactMobile).then(res => {
              this.$set(this.stationDto, 'contactMobile', res)
            })
          } else if (!this.dataVisible.contactMobile) {
            // 还原为原始脱敏数据
            this.$set(this.stationDto, 'contactMobile', this.originData.contactMobile)
          }
          break
        case 'address':
          if (this.dataVisible.address && this.address.message) {
            this.getSourceOrigin(this.address).then(res => {
              this.$set(this.stationDto, 'address', res)
            })
          } else if (!this.dataVisible.address) {
            // 还原为原始脱敏数据
            this.$set(this.stationDto, 'address', this.originData.address)
          }
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 100px;
}

.img-box {
  width: 120px;
  height: 120px;
}

.image-item {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .image-thumb {
    width: 100%;
    height: 100%;
  }

  .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 30px;
  }
}

.video-item {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .video-cover {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    cursor: pointer;

    i {
      font-size: 30px;
      margin-bottom: 4px;
    }

    span {
      font-size: 12px;
    }
  }

  &:hover .video-cover {
    background: #ecf5ff;
    color: #409eff;
  }
}

.video-player-container {
  width: 100%;
  height: 450px;
  background: #000;
  border-radius: 4px;

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.no-data {
  width: 100%;
  text-align: center;
  padding: 20px;
  color: #909399;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/reportBranchExceptionDetail.vue